import "./style.scss";
import PropTypes from "prop-types";
import React from "react";
import Icon from "../../elements/icon";
import SummaryBlock from "./components/SummaryBlock";
import BodyText from "../../elements/body-text";
import { isEmptyObj } from "../../utils/siteUtils";
import { generateReactKey } from "../../utils/reactKey";

const OrderSummary = props => {
  const { heading, itemList, payment, total, disclaimer } = props;
  if (isEmptyObj(props)) return null;
  return (
    <div className="checkout-order-summary">
      <div className="heading-container">
        <div className="heading-content">
          <Icon name="Cart" size="s" />
          <h3 className="type-h3">{heading.title}</h3>
          <p className="caption">{heading.body}</p>
        </div>
      </div>
      <SummaryBlock {...itemList}>
        <ul>
          {itemList.items.map(item => {
            return (
              <li className="body-small" key={generateReactKey()}>
                <span>[</span>
                <div className="white quantity">{item.quantity}</div>
                <span>]</span>
                <span className="white truncate">{item.name}</span>
              </li>
            );
          })}
        </ul>
      </SummaryBlock>
      <SummaryBlock {...payment}>
        <ul>
          <li className="flex-block">
            <p className="body-small">{payment.price.title}</p>
            <p className="body-small white">{payment.price.value}</p>
          </li>
          <li className="flex-block">
            <p className="body-small">{payment.shipping.title}</p>
            <p className="body-small white">{payment.shipping.value}</p>
          </li>
          <div className="flex-block"></div>
        </ul>
      </SummaryBlock>

      <div className="summary-block">
        <div className="flex-block">
          <h4 className="type-h4">{total.title}</h4>
          <h4 className="type-h4">{total.value}</h4>
        </div>
        <BodyText className="caption gray" html={disclaimer} />
      </div>
    </div>
  );
};

OrderSummary.propTypes = {
  heading: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string
  }),
  itemList: PropTypes.shape({
    heading: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        quantity: PropTypes.number
      })
    )
  }),
  payment: PropTypes.shape({
    heading: PropTypes.string,
    price: PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string
    }),
    shipping: PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string
    })
  }),
  total: PropTypes.shape({ title: PropTypes.string, value: PropTypes.string }),
  disclaimer: PropTypes.string
};

export default OrderSummary;
